import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {Contact} from "../../../../model/contact";

import {UserCoordsFormGeneratorService} from "../../../../formulaires/user/user-coords-form-generator.service";
import {DynamicFormComponent} from "../../../../components/common/dynamic-form/dynamic-form.component";
import {QuestionControlService} from "../../../../components/common/fields/question-control.service";
import {FieldDefinition} from "../../../../model/field-definition";

@Component({
    selector: 'app-user-coords-form',
    imports: [
    DynamicFormComponent
],
    templateUrl: './user-coords-form.component.html',
    styleUrls: ['./user-coords-form.component.css']
})
export class UserCoordsFormComponent implements OnInit {

  @Input() parentForm!: UntypedFormGroup;
  @Input() formName: string;
  @Input() user?: Contact;

  questions: FieldDefinition<any>[];
  form: any;

  constructor(private userCoordsFormGeneratorService: UserCoordsFormGeneratorService, private qcs: QuestionControlService) {
  }

  ngOnInit(): void {
    this.userCoordsFormGeneratorService.getQuestions(this.user).subscribe(q => {
      this.questions = q;
      if (this.parentForm.contains(this.formName)) {
        this.form = this.parentForm.controls[this.formName];
      } else {
        this.form = this.qcs.toFormGroup(this.questions, () => {
        });
        this.parentForm.setControl(this.formName, this.form);
      }
    });
  }
}
